import { render, staticRenderFns } from "./MaterialExam.vue?vue&type=template&id=7de0a8b2&scoped=true&"
import script from "./MaterialExam.vue?vue&type=script&lang=js&"
export * from "./MaterialExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de0a8b2",
  null
  
)

export default component.exports